import { setCrossDomainCookie } from '@gto/helpers/cookies'
// import { seg_identify } from '@/helpers/segment'
import router from '@/router'
import { gtm_login_accountLogIn } from '@/helpers/gtm'
import { sessionStore, settingsStore, SettingsSchema } from '@gto/gw-store'
import * as R from 'remeda'

const getInitialState = () => {
  let info = ''
  try {
    info = JSON.parse(localStorage.getItem('user_info'))
  } catch (error) {
    //
  }
  return {
    user_info: {
      email: '',
      public_id: '',
      is_new: false,
      refresh: '',
      affiliate_name: '',
      feature_flags: [],
      credit_balance: 0,
      ...info,
    },
    needToRefresh: false,
  }
}

const state = getInitialState()

const actions = {
  auth_initFromLocalStorage({ dispatch }) {
    try {
      const info = JSON.parse(localStorage.getItem('user_info'))
      if (info) {
        dispatch('setUserInfo', info)
      }
    } catch (error) {
      // console.log(error)
    }
  },
  async login({ dispatch }, data) {
    const { magicLogin, ...rest } = data
    const { response } = await dispatch('api_call', {
      method: 'post',
      hasAuth: false,
      endpoint: magicLogin ? 'magic-login/' : 'account/login/',
      data: rest,
      mutation: 'api_auth',
    })

    if (!response) return
    // to make redirect after login to route under Fflag work on dev - I dont think we need this in prod rn
    const magicFlags = magicLogin ? rest.flags : undefined

    gtm_login_accountLogIn()
    dispatch('auth_handleResponse', { response, magicFlags })
    dispatch(
      'bc_postMessage',
      {
        channelId: 'app',
        data: {
          code: 'logged_in_redirect',
        },
      },
      { root: true },
    )
  },
  auth_handleResponse({ dispatch, commit }, { response, magicFlags }) {
    if (!response) return
    const {
      email,
      is_new,
      public_id,
      refresh,
      token,
      flags: feature_flags,
      ...settings
    } = response.data

    const featureFlags = feature_flags || magicFlags

    const userInfoPayload = {
      email,
      is_new,
      public_id,
      refresh,
      token,
      feature_flags: featureFlags,
    }

    dispatch('setUserInfo', userInfoPayload)
    commit('api_update', {
      key: 'api_account_settings',
      result: {
        response: { data: settings },
        loading: false,
        loaded: true,
        error: null,
      },
    })

    // segment identify call - after login - curr disabled
    // seg_identify({ user_id: public_id, email })

    // keep triton here - its supposed to return at some point when theres another rlf (real-life) tournament
    // const tritonRedirect =
    //   getCookie('GTO_TRITON_REDIRECT') ||
    //   router.currentRoute.value.query?.state?.includes('tritonBoard')
    // if (tritonRedirect) {
    //   const board = getCookie('GTO_TRITON_BOARD') || router.currentRoute.value.query?.tritonBoard
    //   router
    //     .push({
    //       name: 'SurveyTriton',
    //       query: {
    //         tritonBoard: board,
    //       },
    //     })
    //     .catch(() => {})
    //   // dispatch('router_set_dialogs', 'triton-confirm-dialog')
    //   // deleteCookie('GTO_TRITON_REDIRECT')
    //   return
    // }

    dispatch('auth_redirect', userInfoPayload)
  },
  async auth_redirect({ dispatch, getters }, { is_new } = {}) {
    if (is_new) {
      await router.push({ name: 'UserRegistration' })
      return
    }

    if (localStorage.getItem('wait_for_reports') === 'true') {
      const { error } = await dispatch('api_call', {
        method: 'get',
        apiVersion: 'v2',
        endpoint: 'poker/hand-history/reports/active/',
      })
      if (error) {
        setTimeout(async () => dispatch('auth_redirect', is_new), 1000)
        return
      }
      localStorage.removeItem('wait_for_reports')
    }

    const flagRedirect = JSON.parse(localStorage.getItem('flagRedirect') || '{}')

    const redirect =
      flagRedirect?.flag && getters.user_has_flag(flagRedirect.flag)
        ? flagRedirect.path
        : localStorage.getItem('redirect')
    if (!!redirect && !redirect.includes('login')) {
      // localStorage.removeItem('redirect')
      router.push(redirect).catch(() => {})
      return
    }

    // localStorage.removeItem('redirect')
    router.push({ name: 'Dashboard' }).catch(() => {})
  },
  async tokenRefresh({ commit, dispatch, getters }) {
    // let { user_info } = getters
    // const { refresh } = user_info

    const refresh = localStorage.getItem('user_refresh') || getters.user_info.refresh
    if (refresh) {
      commit('setNeedToRefresh', true)
      let { user_info } = getters
      const { response } = await dispatch('api_call', {
        method: 'post',
        endpoint: '/token/refresh/',
        hasCancel: false,
        ignoreNeedToRefresh: false,
        data: {
          refresh,
        },
      })

      commit('setNeedToRefresh', false)
      if (response) {
        const { access } = response.data
        user_info = {
          ...user_info,
          token: access,
        }
        commit('user_info', user_info)

        return { token: access }
      }
    }
    return { token: '' }
  },
  auth_logout({ commit, dispatch }) {
    // dispatch('api_call', { endpoint: 'logout/' })
    commit('api_reset', { key: 'api_account_settings' })
    localStorage.removeItem('user_token')
    localStorage.removeItem('user_refresh')
    localStorage.removeItem('user_info')
    setCrossDomainCookie('GTO_LOGGED_IN', 'no')
  },

  updateUserInfo({ dispatch }, result) {
    if (result?.response?.status === 200) {
      const {
        email,
        is_new,
        public_id,
        token,
        refresh,
        credit_balance,

        subscriptions,
        affiliate_name,
        flags: feature_flags,
      } = result.response.data
      dispatch('setUserInfo', {
        email,
        is_new,
        public_id,
        token,
        refresh,
        credit_balance,

        subscriptions,
        affiliate_name,
        feature_flags,
      })
    }
  },
  setUserInfo(
    { commit, getters },
    {
      email,
      is_new,
      public_id,
      token,
      refresh,
      credit_balance,

      affiliate_name,
      subscriptions,
      feature_flags,
    },
  ) {
    const { user_info } = getters
    let plans = subscriptions?.active_subscriptions

    plans = plans?.map(i => ({
      ...i,
      plan: {
        ...i.plan,
        game_format: i.plan.type,
      },
    }))

    let gtm_plans = null
    if (plans) {
      gtm_plans = plans.map(i => ({
        game: i.plan.game_format,
        type: i.plan.tier,
        paymentType: (i.plan.interval === 'yearly' ? 'annually' : i.plan.interval).toLowerCase(),
        has_access_to_rake_ai: i.plan.has_access_to_rake_ai,
      }))
      gtm_plans = gtm_plans.filter(i => i.game !== 'Any')

      plans = plans.map(i => {
        const external_plan = i.external_plan || { provider: 'Gtowizard' }
        return {
          ...i,
          plan: {
            ...i.plan,
            ...external_plan,
          },
        }
      })
    }

    const res = {
      ...user_info,
      ...(email ? { email } : {}),
      ...(public_id ? { public_id } : {}),
      ...(typeof is_new !== 'undefined' ? { is_new } : {}),
      ...(token ? { token } : {}),
      ...(refresh ? { refresh } : {}),
      ...(credit_balance !== undefined ? { credit_balance } : 0),
      ...(affiliate_name ? { affiliate_name } : {}),
      ...(plans ? { subs: plans } : { subs: [{ plan: { tier: 'FREE', game_format: 'Any' } }] }),
      ...(gtm_plans ? { gtm_plans } : {}),
      feature_flags: feature_flags || [],
    }
    commit('user_info', res)
  },
}

const getters = {
  user_info: state => state.user_info,
  needToRefresh: state => state.needToRefresh,
  has_access_to_rake_ai: (state, getters) =>
    (getters.user_info.subs || []).some(i => i.plan.has_access_to_rake_ai),
  user_has_flag: state => flag => (state.user_info.feature_flags || []).includes(flag),

  // --dev only
  // user_has_flag: state => flag => false,
  // user_has_flag: state => flag =>
  //   [
  //     'CR_REPORTS', //
  //     ...(state.user_info.feature_flags || []),
  //   ].includes(flag),
}

const mutations = {
  user_info(state, user_info) {
    const res = { ...state.user_info, ...user_info }
    state.user_info = res
    sessionStore.getState().setAccessToken(res.token || '')
    settingsStore.getState().setSettings(
      SettingsSchema.parse({
        flags: res.feature_flags || [],
        email: res.email || '',
      }),
    )
    localStorage.setItem('user_refresh', res.refresh || '')
    localStorage.setItem('user_info', JSON.stringify(R.omit(res, ['token'])))
  },
  setNeedToRefresh(state, value) {
    state.needToRefresh = value
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
